import MuiRadioGroup from "@mui/material/RadioGroup";
const RadioGroup = MuiRadioGroup;
export default RadioGroup;
